import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import { UseFormPayload } from '@domain-group/react-hooks'

import InfoToolTip from '@components/InfoToolTip'

import type { AgencyModel } from '@models/types'
import Suburb from './components/Suburb'

interface PropertyAddressProps {
  agency: AgencyModel,
  campaignForm: UseFormPayload,
}

const PropertyAddress = (props: PropertyAddressProps) => {
  const { agency: { geo_country_id }, campaignForm } = props

  const {
    entityState: {
      hide_address,
      legal_description,
      post_code,
      state_name,
      street_name,
      street_number,
      unit_number,
    },
    errors,
    handlers,
  } = campaignForm

  return (
    <DashboardModule title="Property Address">
      <Form padding="large">
        <Form.Row>
          <Form.Row>
            <Form.Field label="Unit No." errorMessage={errors.unit_number}>
              <input
                name="unit_number"
                type="text"
                value={unit_number}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field errorMessage={errors.street_number} label="* Street No." marginTop={['large', 0]}>
              <input
                name="street_number"
                type="text"
                value={street_number}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field errorMessage={errors.street_name} label="* Street Name" marginTop={['large', 0]}>
            <input
              name="street_name"
              type="text"
              value={street_name}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Row>
            <Form.Field label="Postcode" errorMessage={errors.post_code}>
              <input
                name="post_code"
                type="text"
                value={post_code}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="State Name" marginTop={['large', 0]}>
              <input
                name="state_name"
                type="text"
                value={state_name}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          <Suburb
            geo_country_id={geo_country_id}
            campaignForm={campaignForm}
          />
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field
            // @ts-expect-error TS2322
            label={(
              <>
                <Box marginRight="small">Legal Description</Box>

                <InfoToolTip>
                  The description of real estate that is sufficient to identify it for legal purposes e.g. 4//SP6548
                </InfoToolTip>
              </>
            )}
          >
            <input
              name="legal_description"
              type="text"
              value={legal_description}
              {...handlers}
            />
          </Form.Field>

          <Form.Field
            // @ts-expect-error TS2322
            label={(
              <>
                <Box marginRight="small">Address Hidden (Portals)</Box>

                <InfoToolTip>
                  Hides the address on portals e.g. realestate.com.au
                </InfoToolTip>
              </>
            )}
            // @ts-expect-error TS2322
            marginTop={['large', 0]}
          >
            {/*
             // @ts-expect-error TS2322 */}
            <select name="hide_address" value={hide_address} data-value-type="boolean" {...handlers}>
              <option value="false">No</option>
              <option value="true">Yes</option>
            </select>
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default PropertyAddress
